/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
/**
 * Monitoring API
 * Monitoring API for working with device errors
 *
 * The version of the OpenAPI document: 1.20.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Device state severity
 * @export
 * @enum {string}
 */
export enum DeviceStateSeverityEnumModel {
    Ok = 'ok',
    Info = 'info',
    Warning = 'warning',
    Critical = 'critical'
}

